export const layoutSettings = {
  header: {
    height: "64px",
  },
};
